<template>
  <div class="tw-text-sm font-normal whitespace-pre-line wrap-break-word">
    {{storeAnswer.data.value}}
  </div>
</template>
<script>
import mixin from './_mixin_display'
export default { mixins: [mixin] }
</script>